import { render, staticRenderFns } from "./ShippingCosts.vue?vue&type=template&id=51a15d28&"
import script from "./ShippingCosts.vue?vue&type=script&lang=js&"
export * from "./ShippingCosts.vue?vue&type=script&lang=js&"
import style0 from "./ShippingCosts.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports